import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context'; // Import the authentication hook
import './Dashboard.css'; // Import styles for cards
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const Dashboard = () => {
    const [appointments, setAppointments] = useState([]);
    const [error, setError] = useState(null);
    const auth = useAuth();
    const [status] = useState('not-draft');
    const [employeeId] = useState('myself'); // Default to 'myself'
    // Initialize startDate to today's date
    const [startDate] = useState(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set time to 00:00:00
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero for months < 10
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero for days < 10
    
        // Return the formatted date as 'YYYY-MM-DD 00:00:00'
        return `${year}-${month}-${day} 00:00:00`;
    });

  // Fetch appointments from the backend
  useEffect(() => {
    const fetchAppointments = async () => {
      if (auth.isAuthenticated && auth.user?.access_token) {
        try {
            const response = await fetch(`https://api.currentix.de/api/appointments?employeeId=${employeeId}&startDate=${startDate}&status=${status}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${auth.user.access_token}`,  // Attach the token here
            }
          });

          if (response.ok) {
            const data = await response.json();
            setAppointments(data.appointments);
          } else {
            throw new Error('Failed to fetch appointments');
          }
        } catch (err) {
          setError(err.message);
        }
      }
    };

    fetchAppointments();
  }, [auth, employeeId, startDate, status]);

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>
      {error && <p>Error: {error}</p>}
      {appointments.length === 0 ? (
        <p>No appointments available</p>
      ) : (
        <div className="appointments-container">
          {appointments.map((appointment) => (
              <AppointmentCard
              key={appointment.idAppointment}
              appointment={appointment}
              setAppointments={setAppointments} // Pass setAppointments here
            />
          ))}
        </div>
      )}
    </div>
  );
};

const AppointmentCard = ({ appointment, setAppointments }) => {
  const navigate = useNavigate(); // Initialize the navigate hook
  const auth = useAuth();
  const [expanded, setExpanded] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(appointment.status);

  // Handle status change
  const handleStatusChange = async (newStatus) => {
    setSelectedStatus(newStatus);
    setIsDropdownVisible(false);

    try {
        const response = await fetch(`https://api.currentix.de/api/appointments/${appointment.idAppointment}/status`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth.user.access_token}`,  // Attach the token here
              },
            body: JSON.stringify({ status: newStatus }),
          });
  
        if (response.ok) {
            setAppointments((prevAppointments) => {
                return prevAppointments.map((appt) =>
                  appt.idAppointment === appointment.idAppointment
                    ? { ...appt, status: newStatus } // Updating the status locally
                    : appt
                );
              });
            console.log('Status updated successfully');
        } else {
          console.error('Failed to update status');
        }
      } catch (err) {
        console.error('Error updating status:', err);
      }
    };

      // Get card color based on status
    const getCardColor = (status) => {
        switch (appointment.status) {
            case 'Scheduled': return 'grey';
            case 'Completed': return 'green';
            case 'Cancelled': return 'red';
            case 'In Progress': return 'blue';
            default: return 'grey';
        }
    };

return (
    <div className="appointment-card" style={{ backgroundColor: getCardColor(selectedStatus) }}>
        <div className="card-header" onClick={() => setExpanded(!expanded)}>
        <h4>{appointment.workDescription.split('<br>').map((line, index) => (
              <span key={index}>
                  {line}
                  <br />
                  </span>
          ))}
        </h4>
        <p className="no-margin">{new Date(appointment.appointmentStart).toLocaleString()}</p>
        </div>


        {expanded && (
        <div className="card-details">
            <div className="status-container">
            <button
                className="status-button"
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}
            >
                {selectedStatus}
            </button>

            {isDropdownVisible && (
                <div className="dropdown">
                {['Scheduled', 'Completed', 'Cancelled', 'In Progress'].map((status) => (
                    <div key={status} onClick={() => handleStatusChange(status)} className="dropdown-item">
                    {status}
                    </div>
                ))}
                </div>
            )}
            </div>
            <p><strong>Location:</strong> {appointment.location}</p>
            <p><strong>Electricians Assigned:</strong> {appointment.electriciansAssigned}</p>
            <p><strong>Travel Start:</strong> {new Date(appointment.appointmentStartTravel).toLocaleString()}</p>
            <p><strong>End Time:</strong> {new Date(appointment.appointmentEnd).toLocaleString()}</p>
            <button 
            className="details-button"
            onClick={() => navigate(`/order-details/${appointment.idOrder}`)} // Navigate to order-details page
            >
              View Customer Details
            </button>
        </div>
        )}
    </div>
    );
};

export default Dashboard;
